import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Challenge from './Challenge';
import Program from './Program';
import Main from './Main';
import * as serviceWorker from './serviceWorker';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';

const routing = (
  <Router>
    <div>
      <Route exact path="/" component={Main} />
      <Route path="/challenge/:id" component={Challenge} />
      <Route path="/program/:id" component={Program} />
    </div>
  </Router>
)


ReactDOM.render(
  <React.StrictMode>
    {routing}
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
